export default {
  notFound: {
    seo: { title: 'Page introuvable' },
    badge: 'Erreur 404',
    title: 'Vous êtes hors itinéraire',
    description:
      'L\'URL demandée n\'est pas sur notre carte. Vérifiez l\'adresse, retournez à l\'accueil ou contactez-nous si vous avez besoin d\'aide.',
    requestedPathLabel: 'Chemin demandé',
    backHome: 'Retour à l\'accueil',
    contactUs: 'Nous contacter',
    pricing: 'Tarifs',
    tagline: 'Geofleet · Dernière mile et opérations de flotte',
  },
};
